import { Api } from 'utils';

class BotpressService {
  static get = async (params = {}) =>
    Api.createResponse('app/botpress/', params);
  static send = async (params = {}) =>
    Api.createResponse('app/botpress/send', params);
}

export default BotpressService;
